import * as React from 'react';

function SvgSend(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M21.193 10.793l-.007-.003L3.39 3.408a.982.982 0 00-.926.09A1.027 1.027 0 002 4.356v4.721a1 1 0 00.813.982l9.707 1.795a.167.167 0 010 .328l-9.706 1.794a1 1 0 00-.814.982v4.721a.982.982 0 00.441.82.999.999 0 00.948.087l17.796-7.34.008-.003a1.332 1.332 0 000-2.45z" })));
}

export default SvgSend;
